module.exports = __webpack_public_path__ + "img/calendar_money.aa541c2c.svg";